import { useContext } from 'react';
import { EmbedModeContext } from './services/provider';

export const useIsEmbedMode = () => useContext(EmbedModeContext);

export { EmbedModeProvider, EmbedModeContext } from './services/provider/index';
